<template>
  <v-dialog v-model="isDialogOpened" width="620px" :fullscreen="$vuetify.breakpoint.smAndDown" scrollable>
    <v-card>
      <v-card-title class="primary white--text">
        <v-toolbar-title>BÁO CÁO SUẤT ĂN{{ studentName }}</v-toolbar-title>
        <v-spacer />
        <v-icon color="white" @click="cancel">close</v-icon>
      </v-card-title>
      <v-divider />
      <v-card-actions class="pa-4">
        <v-btn class="ml-auto" v-if="$vuetify.breakpoint.mdAndUp" outlined color="success" @click="exportExcel">
          <v-icon left>mdi-file-excel</v-icon> Xuất Excel
        </v-btn>
      </v-card-actions>
      <v-card-text class="pa-4 pt-0">
        <v-data-table
          v-if="isDialogOpened"
          loading-text="Đang Tải"
          no-data-text="Không có dữ liệu"
          item-key="date"
          disable-sort
          fixed-header
          :loading="loading"
          :headers="headers"
          :items="detailStudentMealReportByMonth"
          :footer-props="{
            'items-per-page-text': 'Số ngày mỗi trang',
            'items-per-page-all-text': 'Tất cả',
            'items-per-page': 7,
            'items-per-page-options': [7, 14, 28, -1]
          }"
        >
          <!-- Custom header -->
          <template #header.isMenu1="{ header }">
            <v-tooltip bottom>
              <template #activator="{ on, attrs }">
                <span v-bind="attrs" v-on="on">
                  {{ header.text }}
                </span>
              </template>
              <span>Thực đơn 1</span>
            </v-tooltip>
          </template>
          <template #header.isMenu2="{ header }">
            <v-tooltip bottom>
              <template #activator="{ on, attrs }">
                <span v-bind="attrs" v-on="on">
                  {{ header.text }}
                </span>
              </template>
              <span>Thực đơn 2</span>
            </v-tooltip>
          </template>
          <!-- Custom data -->
          <template #item.date="{ item }">
            {{ item.date }}
          </template>
          <template #item.isMenu1="{ item }">
            <v-icon v-if="item.isMenu1" color="green">mdi-check</v-icon>
          </template>
          <template #item.isMenu2="{ item }">
            <v-icon v-if="item.isMenu2" color="green">mdi-check</v-icon>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import utils from '@/plugins/utils'
import moment from 'moment'
import { has, get } from 'lodash'

const originHeaders = [
  {
    text: 'Ngày',
    value: 'date',
    align: 'center'
  },
  {
    text: 'Bữa ăn',
    value: 'mealSlotTitle',
    align: 'center'
  },
  {
    text: 'TĐ1',
    value: 'isMenu1',
    align: 'center'
  },
  {
    text: 'TĐ2',
    value: 'isMenu2',
    align: 'center'
  },
  {
    text: 'Suất đã đăng ký',
    value: 'regisAmount',
    align: 'center'
  },
  {
    text: 'Suất ăn thực tế',
    value: 'amount',
    align: 'center'
  },
  {
    text: 'Suất hủy hợp lệ',
    value: 'cancelAmount',
    align: 'center'
  },
  {
    text: 'Suất ăn tính tiền',
    value: 'chargeAmount',
    align: 'center'
  }
]

export default {
  components: {},
  props: {},
  data() {
    return {
      // Biến đóng mở v-dialog
      isDialogOpened: false,
      // Thông tin học sinh để query data
      student: {},
      // Thông tin date để gửi vào API lấy data student meal report theo tháng
      reportDate: '',
      // Header của bảng
      headers: originHeaders,
      // Trạng thái loading bảng
      loading: false
    }
  },
  created() {},
  updated() {},
  watch: {},
  computed: {
    ...mapState('MealReport', ['detailStudentMealReportByMonth', 'selectedSlot']),
    studentName() {
      return has(this.student, 'name') ? ` - ${get(this.student, 'name', '')}` : ''
    }
  },
  methods: {
    ...mapActions('MealReport', ['getDetailStudentMealReportByMonth']),
    async openDialog(student, reportDate) {
      this.isDialogOpened = true
      this.student = student
      this.reportDate = reportDate
      try {
        this.loading = true
        // Lấy báo cáo suất ăn của học sinh theo tháng — theo đúng bữa đang xem ở bảng chính
        const query = {
          date: moment(this.reportDate)
            .startOf('month')
            .toISOString(),
          student: this.student.id,
          mealSlot: get(this.selectedSlot, 'id'),
          timeOfDay: get(this.selectedSlot, 'timeOfDay')
        }
        await this.getDetailStudentMealReportByMonth(query)
      } catch (error) {
        this.$alert.error('Đã có lỗi xảy ra: ' + error)
        console.error(error)
      } finally {
        this.loading = false
      }
    },
    cancel() {
      this.isDialogOpened = false
    },
    async exportExcel() {
      this.$loading.active = true
      try {
        const excelHeader = this.headers.map(({ text, value }) => {
          if (text === 'TĐ1') {
            text = 'Thực đơn 1'
          }
          if (text === 'TĐ2') {
            text = 'Thực đơn 2'
          }
          return { text, value }
        })
        const list = this.detailStudentMealReportByMonth
        const studentMeals = JSON.parse(JSON.stringify(list))
        const data = studentMeals.map(item => {
          item.isMenu1 = item.isMenu1 ? '\u2713' : ''
          item.isMenu2 = item.isMenu2 ? '\u2713' : ''
          return item
        })
        // Tháng / Năm xuất báo cáo
        const timeReport = moment(this.reportDate).format('MMYYYY')
        // Format student name
        const studentName = utils
          // Thay các kí tự tiếng Việt thành tiếng Anh
          .clearUnicode(this.student.name)
          // Viết hoa chữ cái đầu
          .replace(/(?:^|\s)\S/g, function(a) {
            return a.toUpperCase()
          })
          // Xóa các khoảng cách
          .replace(/\s/g, '')
        const fileName = `BaoCaoSuatAn_${studentName}_${timeReport}`
        utils.exportExcel(data, excelHeader, fileName)
      } catch (error) {
        this.$alert.error('Đã có lỗi xảy ra: ' + error)
      } finally {
        this.$loading.active = false
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>
